import { tryCatch } from '@thalesrc/js-utils';

import HSApi from '../HSApi';
import { GetBuildingsResult } from './get-buildings.result';
export async function getBuildings(): Promise<GetBuildingsResult[]> {
  const [error, res] = await tryCatch(HSApi.get<GetBuildingsResult[]>(`/buildings`));

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }

  return res.data;
}
